import { createContext } from 'react';
const InviteSeatsContext = /*#__PURE__*/createContext(null);
export default InviteSeatsContext;